import styled from 'styled-components'

export const MultiSelectDropdownContainer = styled.div`
  width: 100%;
  margin-bottom: ${(props) => {
    return props.marginBottom
  }};
`

export const MultiSelectInputWrapper = styled.div`
  width: 100%;
  display: inline;
  margin-top: ${(props) => {
    return props.marginTop
  }};
`

export const MultiSelectIconContainer = styled.div`
  position: relative;
`

export const MultiSelectIconWrapper = styled.div`
  position: absolute;  
  top: 12px;
  left: 8px;
  z-index: 1;
`

export const Label = styled.label`
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #202020;
  display: flex;
  align-items: center;
  margin-bottom: ${(p) => {
    return p.marginBottomLabel ? p.marginBottomLabel : '16px'
  }};
  justify-content: space-between;

  div {
    cursor: pointer;
  }

  svg {
    margin: 0 8px;
  }

  span {
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    color: rgba(32, 32, 32, 0.5);
  }
`
